import { ITab } from 'components/common/CustomizedTabs/CustomizedTabs';

import { CardTab } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/CardTab/CardTab';

export type RiskRegisterFormTabs = 'details' | 'linkedActivities' | 'auditLog';

export const tabsArrData: ITab<RiskRegisterFormTabs>[] = [
    {
        value: 'details',
        label: <CardTab title={'Card Details'} />,
    },
    {
        value: 'linkedActivities',
        label: <CardTab title={'Linked Activities'} />,
    },
    {
        value: 'auditLog',
        label: <CardTab title={'Audit Log'} />,
    },
];
